export default class PathwayDegreeCourseModel {
  constructor(pathwayInfo) {
    if (!pathwayInfo) return;

    this._pathwayId = pathwayInfo.pathwayId;
    this._pathwayName = pathwayInfo.pathwayName;
    this._pathwayDescription = pathwayInfo.pathwayDescription;
    this._imageUrl = pathwayInfo.imageUrl;
    this._interestArea = pathwayInfo.interestArea;
    this._isActive = pathwayInfo.isActive;
    this._minGPA = pathwayInfo.minGPA;
    this._urlNavigationParam = pathwayInfo.urlNavigationParam;
    this._credits = pathwayInfo.credits;
    this._outcome = pathwayInfo.outcome;
    this._prerequisites = pathwayInfo.prerequisites || 'none';
    this._partnerId = pathwayInfo.partnerId;
    this._isCumulative = pathwayInfo.isCumulative;
    this._location = pathwayInfo.location;
    this._recommendedCourses = pathwayInfo.recommendedCourses;
    this._requiredCourses = pathwayInfo.requiredCourses;
    this._recommendedCreditDesignations = pathwayInfo.recommendedCreditDesignations;
    this._requiredCreditDesignations = pathwayInfo.requiredCreditDesignations;
    this._admissionRequirements = pathwayInfo.admissionRequirements;

    this._pathwayCourses = [];
  }
}
